export default "__VITE_ASSET__BS5Wo1_p__";